import React from "react";
import { Result } from "antd";
import { ModalPadrao } from "./Base";
import { BtnSair } from "./Buttons";

export default function ErroModal({ title, subTitle, visible, onCancel, width, children }) {

  return <ModalPadrao width={width || 700} visible={visible} onCancel={onCancel} footer={<BtnSair onClick={onCancel} />}>
    <Result style={{ margin: 0, padding: 0, paddingTop: 20 }} status="warning" title={title} subTitle={subTitle} />
    {children}
  </ModalPadrao>;
}